var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-block",class:[
    'color-block_' + _vm.item.bg,
    {
      'color-block_red': _vm.item.red,
      'color-block_v2': _vm.item.smallPadding
    }
  ]},[_c('div',{staticClass:"color-block__inner"},[(_vm.item.title)?_c('div',{staticClass:"page-title page-title_2",domProps:{"innerHTML":_vm._s(_vm.$getTranslate(_vm.item.title))}}):_vm._e(),(_vm.item.text)?_c('div',{staticClass:"color-block__text",domProps:{"innerHTML":_vm._s(_vm.$getTranslate(_vm.item.text))}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }